exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".acd_wraper1MwBe {\n  padding: 3%; }\n  .acd_wraper1MwBe > div {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    padding: 0;\n    width: 100%; }\n\n.acd_bgWhite30Yya {\n  background: #fff; }\n", ""]);

// exports
exports.locals = {
	"wraper": "acd_wraper1MwBe",
	"bgWhite": "acd_bgWhite30Yya"
};